import { mergeAttributes, Node, nodeInputRule } from "@tiptap/core";

export interface DashedItemOptions {
  nested: boolean;
  HTMLAttributes: Record<string, any>;
}

export const inputRegex = /^\s*(\[([ |x])\])\s$/;

const DashedItem = Node.create<DashedItemOptions>({
  name: "dashedItem",

  addOptions() {
    return {
      nested: false,
      HTMLAttributes: {},
    };
  },

  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },

  defining: true,

  addAttributes() {
    return {
      checked: {
        default: false,
        keepOnSplit: false,
        parseHTML: (element) => element.getAttribute("data-checked") === "true",
        renderHTML: (attributes) => ({
          "data-checked": attributes.checked,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `li`,
        priority: 51,
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "li",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": this.name,
        className: "dashed-item",
      }),
      ["div", 0],
    ];
  },

  addKeyboardShortcuts() {
    const shortcuts = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name),
    };

    if (!this.options.nested) {
      return shortcuts;
    }

    return {
      ...shortcuts,
      Tab: () => this.editor.commands.sinkListItem(this.name),
    };
  },

  addInputRules() {
    return [
      nodeInputRule(inputRegex, this.type, (match) => ({
        checked: match[match.length - 1] === "x",
      })),
    ];
  },
});

export default DashedItem;
